module.exports = __webpack_public_path__ + "img/flow_get-app_hover.a1d5ec17.svg";